/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResidualRiskLabel } from './ResidualRiskLabel';
import {
  ResidualRiskLabelFromJSON,
  ResidualRiskLabelFromJSONTyped,
  ResidualRiskLabelToJSON,
} from './ResidualRiskLabel';

/**
 *
 * @export
 * @interface PaginatedResidualRiskLabelList
 */
export interface PaginatedResidualRiskLabelList {
  /**
   *
   * @type {number}
   * @memberof PaginatedResidualRiskLabelList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedResidualRiskLabelList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedResidualRiskLabelList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<ResidualRiskLabel>}
   * @memberof PaginatedResidualRiskLabelList
   */
  results: Array<ResidualRiskLabel>;
}

/**
 * Check if a given object implements the PaginatedResidualRiskLabelList interface.
 */
export function instanceOfPaginatedResidualRiskLabelList(value: object): value is PaginatedResidualRiskLabelList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedResidualRiskLabelListFromJSON(json: any): PaginatedResidualRiskLabelList {
  return PaginatedResidualRiskLabelListFromJSONTyped(json, false);
}

export function PaginatedResidualRiskLabelListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedResidualRiskLabelList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(ResidualRiskLabelFromJSON),
  };
}

export function PaginatedResidualRiskLabelListToJSON(value?: PaginatedResidualRiskLabelList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(ResidualRiskLabelToJSON),
  };
}
